import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  datepickerInputContainer: {
    flexWrap: 'nowrap',
    '& .MuiGrid-root:first-child .MuiInputBase-root': {
      borderRight: 'none',
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    '& .MuiGrid-root:last-child .MuiInputBase-root': {
      borderLeft: 'none',
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
  },
  datepickerInputContainerEnd: {
    flexWrap: 'nowrap',
    '& .MuiGrid-root:first-child .MuiInputBase-root': {
      borderColor: Theme.palette.primary.light,
    },
    '& .MuiGrid-root:last-child .MuiInputBase-root': {
      borderLeft: 'none',
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
  },
  datepickerInputContainerStart: {
    flexWrap: 'nowrap',
    '& .MuiGrid-root:first-child .MuiInputBase-root': {
      borderRight: 'none',
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    '& .MuiGrid-root:last-child .MuiInputBase-root': {
      borderColor: Theme.palette.primary.light,
    },
  },
  inputAdornment: {
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  inputAdornmentEnd: {
    marginLeft: '-16px !important',
  },
  datepickerInput: {
    margin: '0 !important',
  },
  datePickerOneWay: {
    '& .MuiGrid-root:last-child .MuiInputBase-root': {
      border: `solid 1px ${Theme.palette.gray[300]}`,
    },
  },
  gridItem: {
    [Theme.breakpoints.up('xs')]: {
      padding: '17px 10px 17px 10px !important',
    },
    [Theme.breakpoints.up('sm')]: {
      padding: '17px 10px 17px 10px !important',
    },
    [Theme.breakpoints.up('md')]: {
      padding: '20px 10px 20px 10px !important',
    },
    [Theme.breakpoints.up('lg')]: {
      padding: '20px 15px 20px 15px !important',
    },
  },
}));

export default useStyles;
